import FinancialDepartment3 from "../components/admin-panel/financial-department/Index";

import ManagementSidebar from "components/common/ManagementSidebar";
const FinancialManagement = () => {
  return (
    <>
      <div className=" d-flex w-100">
        {/* <ManagementSidebar></ManagementSidebar> */}
        <div className="w-100">
          <FinancialDepartment3 />
        </div>
      </div>
    </>
  );
};

export default FinancialManagement;
